import getAPIResponse from "./common/Common";

export async function getM3U(publicPath) {
	return await getAPIResponse("/m3u/" + publicPath);
}